export const LANGUAGE_AND_COUNTRY_LENGTH = 5;
